import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';
import MatchDots from '../../components/ExcerciseTypes/LineTo/MatchDots';
const json = {
  1:{
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page5/Key/E1answerKey.jpg",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    inputSize: 81,
    textareaStyle:{width:800},
    titleQuestion: [
      {
        num: "",
        title: `
        <div style='margin-left:120px;font-size:30px;color:rgb(102 96 132)'>VIẾT ĐOẠN VĂN NÊU Ý KIẾN</div>
				`,
        color: "rgb(29,193,215)",
      },
    ],
    
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    isEssay:true,
    questions: [
      {
        title: `
            <div style='width:20cm;border: 5px solid rgb(29,193,215);padding:5px 10px;border-radius:20px;box-shadow:0px 2px 3px 4px gray'>
              
              <b>Đề bài:</b> Viết đoạn văn nêu lý do yêu thích một câu chuyện về tình cảm gia đình mà em đã đọc hoặc đã nghe <br>
             
            </div>   
          <div style='width:20cm;margin:20px 0px'>
            <div>
              <b style='color:rgb(3, 103, 181)'>1.</b>&ensp;Dựa vào các ý đã tìm trong hoạt động Viết của bài 3, viết đoạn văn nêu lí do. 
               yêu thích của một câu chuyện đã đọc hoặc đã nghe.<br>
               Lưu ý:<br>
              - Chọn cách giới thiệu câu chuyện gây được chú ý và nêu nhận xét, đánh giá chung về câu chuyện.<br>
              - Trình bày rõ các lí do yêu thích câu chuyện và đưa ra dẫn chứng minh họa.
              - Các câu trong đoạn văn được viết liên tục, không xuống dòng.
            </div>
              <b style='color:rgb(3, 103, 181)'>2.</b>&ensp; Đọc soát và chỉnh sửa bài viết.<br>
            <div style='width:25cm'>
              <span style='background:yellow; padding:6px 40px; text-align:center'>
                Cách mở đoạn
              </span>            
              <span style='background:rgb(227 199 202); padding:6px 40px; text-align:center;margin:0px 10px'>
                Cách trình bày lí do
              </span>            
              <span style='background:rgb(204 218 221); padding:6px 40px; text-align:center'>
                Cách kết thúc
              </span>            
            </div>
            <div style='width:20cm;margin:20px 70px'>
              <span style='background:yellow; padding:6px 40px; text-align:center;margin:0px 10px'>
                Cách dùng từ
              </span>            
              <span style='background:rgb(227 199 202); padding:6px 40px; text-align:center'>
                Cách thức trình bày đoạn văn
              </span>            
                      
            </div>
            
              <b style='font-weight:bold'>
                 Bài làm:
              </b>
                    <textarea id='0' rows='8'></textarea>
        <span style='color:red;background-color:green;padding:0'>☆</span>
        `,
        answer: ["Do",  "has",  "doesn't",  "Does" , "'m",  "'re", 
           "having",  "aren't" , "isn't",  "Is"
          
        ],
      },
    ],
  },


  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E2",
    audio: "",
    video: "",
    // recorder: true,
    // exerciseKey: "/img/FriendsPlus/Page4/Key/E2answerKey.jpg",
    component: Circle_Write,

    titleQuestion: [
      {
        num: "",
        title: `
			<img src='/img/FriendsPlus/Page2/E2/1.jpg' style='height:15mm;margin-right:50px' /> <span style='text-align:center;font-weight:bold;color:#5d4c80'>ANH EM SINH ĐÔI</span>
		
		`,
        color: "rgb(3, 103, 181)",
      },
    ],
    textareaStyle:{width:750},
		question: {
			Write: {

				inputStyle: { width:750, padding: 20 },
				answers: [],
				initialValue: [],
			},
			Circle: {
				initialWordStyle: { border: 'none', borderRadius: '50%', borderColor: 'transparent', fontWeight: 'bold' },
				// initialWordSt<yle: { fontWeight: 'bold', border: 'none',  borderColor: 'transparent' },
				selectWordStyle: {padding:"5px", border: '2px solid', borderColor: 'gray' },
				limitSelect: 1,
				listWords: [
					`A|. <br> B|. <br> C|. <br><br> D|. `,
					`A. <br> B. <br> C. <br> D.`,
					`A. <br> B. <br> C. <br> D.`,
					
				],
				answers: ['0-0', '1-0', '2-0', '3-4', '4-4', '5-0', '6-0', '7-4', '8-0'],

				initialValue: [],
			},
			Layout: `
      <div style='width:25cm'>
      &emsp;Sau bữa ăn trưa, cô giáo thông báo Giét-xi được chọn đóng vai công chúa trong vở kịch sắp tới. Cảm nhận được
      ánh mắt ngưỡng mộ của bạn bè, Giét-xi vui lắm.<br>
      &emsp;Về nhà, Giét-xi hào hứng kể cho mẹ nghe. Cả tuần ấy, tối nào mẹ cũng tập lời thoại cùng Giét-xi. Giét-xi  chăm chỉ 
      luyện tập và nhớ lời thoại rất nhanh. Nhưng khi lên sân khấu diễn thử, mọi lời thoại trong đầu Giét-xi đều bay đi đâu hết. 
      Cuối cùng, cô giáo đành nói:<br>
      &emsp;- Giét-xi à, cô đã bổ sung vai dẫn chuyện cho vở kịch. Cô nghĩ vai đó hợp với em hơn. Em có đồng ý đổi vai không? <br>
      &emsp;Lời nói cô rất dịu dàng nhưng Giét-xi thấy buồn lắm. Sao không buồn khi phải nhường vai chính cho bạn!<br>
      &emsp;Thấy Giét-xi buồn, mẹ thủ thỉ:<br>
      &emsp;- Hôm nay mẹ con mình cùng nhau nhổ vườn cỏ nhé.<br>
      &emsp;Khu vườn vào xuân, những cây hồng leo khóa tấm áo xanh mới.<br>
      &emsp;- Mẹ con mình sẽ nhổ hết cỏ và hoa dại ở đây. Từ giờ vườn nhà ta chỉ có hoa hồng thôi. - Vừa nói, mẹ vừa chạm tay vào khóm bồ công anh.<br>
      &emsp;- Đừng, mẹ! Con thích hoa bồ công anh. Loài hoa nào cũng đẹp cả, kể cả bồ công anh. - Giét-xi nói.<br>
      &emsp;Mẹ mỉm cười:<br>
      &emsp;- Đúng rồi, mỗi loài hoa đều có một vẻ đẹp riêng con ạ. Con người cũng vậy, không phải ai cũng thành công chúa, nhưng điều đó không có gì đáng xấu hổ.<br>
      &emsp;Giét-xi đoán mẹ đã biết chuyện thay vai diễn của mình.<br>
      &emsp;Mẹ dịu dàng nói.<br>
      &emsp;- Con gái bé nhỏ của mẹ, con có giọng đọc truyền cảm, rất hợp với vai người dẫn chuyện. Nếu thiếu người dẫn chuyện, vở kịch cũng khó mà thành công được con ạ.<br>

      <div style='text-align: end'>(Du-nan biên soạn, Hòa Vân dịch)</div>
    </div>

    <div style='display:flex;margin-top:20px'>
      <img src='/img/FriendsPlus/Page3/E1/1.jpg' style='height:15mm;margin-right:20px' />
      <div style='width:20cm'>
          <b style='color:rgb(151 30 17)'>1.</b>&ensp;Tìm các câu văn thể hiện thái độ của Giét-xi đối với 1 vai diễn được giao.<br><input id='0'></input><br>
          <b style='color:rgb(151 30 17)'>2.</b>&ensp;Vì sao Giét-xi phải buồn khi đổi sang vai người dẫn chuyện?<br><input id='1'></input><br>
        <div>
          <b style='color:rgb(151 30 17)'>3.</b>&ensp;Theo em mẹ rủ Giét-xi cùng nhổ cỏ vườn để làm gì? Tìm câu trả lời đúng.<br>
          <div style='display:flex;margin:0px 25px'>
            <div>
              <input id='0' type='Circle'/>
            </div>
            <div style='margin:0px 5px'>
              Mẹ muốn dạy cho Giét-xi biết cách làm cỏ vườn.<br>
              Mẹ muôn Giét-xi biết tên các loài hoa, cỏ trong vường.<br>
              Mẹ muốn Giét-xi hiểu: Như các loài hoa, mỗi người có vẻ đẹp và giá trị riêng.<br>
              Mẹ muốn Giét-xi quên đi chuyện đóng kịch.
            </div>
          </div>
        </div>
          <b style='color:rgb(151 30 17)'>4.</b>&ensp;Đoán xem Giét-xi đã cảm thấy như thế nào khi được trò chuyện cùng mẹ.<br><input id='2'></input><br>
          <b style='color:rgb(151 30 17)'>5.</b>&ensp;Em đã học được điều gì từ câu chuyện trên?<br><input id='3'></input><br>
      </div>
    </div>
    <div style='display:flex;'>
        <img src='/img/FriendsPlus/Page7/E2/1.jpg' style='height:15mm;margin-right:20px' /> 
        <div  style='width:20cm'>
          <b style='color:rgb(151 30 17)'>1.</b>&ensp;Tìm các danh từ chỉ người trong bài đọc Công chúa và người dẫn chuyện.<br><input id='4'></input><br>
          <b style='color:rgb(151 30 17)'>2.</b>&ensp;Viết 2 - 3 câu nêu nhận xét về một nhân vật mà em yêu thích trong câu chuyện trên.<br><textarea id='5' rows='3'></textarea><br>
        </div>
    </div>


        
         `,
		},},
  
};

export default json;
